
import URI from 'urijs';
import isArray from 'lodash/isArray';

import ErrorHttp from './utils/ErrorHttp';

import loadJsonFromText from './utils/loadJsonFromText';
import loadJsonFromUrl from './utils/loadJsonFromUrl';
import loadTextFromUrl from './utils/loadTextFromUrl';

const DEFAULT_API_BASE_URL = '';
const OUTPUT_TYPE_JSON = 'JSON';
const OUTPUT_TYPE_TEXT = 'TEXT';

// ToDo: global variable
let _apiBaseUrl = DEFAULT_API_BASE_URL;

function callFunctionGet(module, version, name, params, outputType, callback) {
    let url = getFunctionUrl(module, version, name, params);

    callback = callback || (() => {});

    switch (outputType) {
        case OUTPUT_TYPE_JSON:
            loadJsonFromUrl(url, (err, response) => {
                callback(err, response);
            });
            break;
        case OUTPUT_TYPE_TEXT:
            loadTextFromUrl(url, (err, response) => {
                callback(err, response);
            });
            break;
        default:
            console.warn(`Bad type of output for call function: ${outputType}`);
    }
}

function getDefaultRequestOptions(options) {
    let contentType = options.contentType || 'application/json';

    let reqOptions = {
        mode: 'cors',
        headers: {
            'Content-Type': contentType
        }
    };

    if (options.token) {
        reqOptions.headers = {
            ...reqOptions.headers,
            'Authorization': (options.token) ? `Token ${options.token}` : ''
        }
    }

    if (options.reqOptions) {
        reqOptions = {
            ...reqOptions,
            ...options.reqOptions
        };
    }

    return reqOptions;
}

function callGet(options) {
    let url = getFunctionUrl(options.module, options.version, options.name, options.params);
    let callback = options.callback || (() => {});

    let reqOptions = {
        ...getDefaultRequestOptions(options),
        method: 'GET'
    };

    doFetch(url, reqOptions, callback);
}

function callPost(options) {
    let url = getFunctionUrl(options.module, options.version, options.name);
    let callback = options.callback || (() => {});

    let reqOptions = {
        ...getDefaultRequestOptions(options),
        method: 'POST',
        body: JSON.stringify(options.body),
    };

    doFetch(url, reqOptions, callback);
}

function doFetch(url, reqOptions, callback) {
    fetch(url, reqOptions)
        .then(response => {
            if (response.ok) {
                return response.text();
            } else {
                return response.text()
                    .then(text => {
                        throw new ErrorHttp(
                            'Internal error in call server API',
                            response.status,
                            text
                        );
                    });
            }
        })
        .then(content => {
            loadJsonFromText(content, callback);
        })
        .catch(error => {
            console.error('fetch failed:', error, error.status, error.body);
            callback(error);
        });
}

function getApiBaseUrl() {
    return _apiBaseUrl;
}

// ToDo: version
function getFunctionUrl(module, version, name, params) {
    let url = `${getApiBaseUrl()}/api/${module}/${name}`;
    let uri = new URI(url);
    if (isArray(params)) {
        params.forEach(item => {
            uri.setSearch(item[0], item[1]);
        });
    }

    return uri.toString();
}

function init(options) {
    options = options || {};
    if (options.apiBaseUrl) {
        setApiBaseUrl(options.apiBaseUrl);
    }
}

function setApiBaseUrl(url) {
    _apiBaseUrl = url;
    console.log(`API URL base used: ${_apiBaseUrl}`);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    OUTPUT_TYPE_JSON,
    OUTPUT_TYPE_TEXT,

    callFunctionGet,
    callGet,
    callPost,
    doFetch,
    getApiBaseUrl,
    init
};
